<div class="inside-container">
    <div fxLayout="row">
        <div fxFlex="50" fxLayoutAlign="start center">
            <h3
                class="tab-header"
                i18n="@@fcd8ef2a1fb746b34dd85aa6170b2b58cff7aa2d"
                t="fcd8ef2a1fb746b34dd85aa6170b2b58cff7aa2d"
            >
                Loaner Wheel Inventory
            </h3>
        </div>
    </div>
    <br />
    <div fxLayout="row">
        <div fxFlex="90">
            <p class="tab-details">
                <b
                    i18n="@@99e6df02a2f598db23f2cfbe7201e16e082223cd"
                    t="99e6df02a2f598db23f2cfbe7201e16e082223cd"
                    >Please Note:
                </b>
                <span
                    i18n="@@a4d9856f29aa150495207e8655ff361a2e57648a"
                    t="a4d9856f29aa150495207e8655ff361a2e57648a"
                    >To add more locations or for any assistance please contact your company's Regional Network
                    Manager.</span
                >
                <br />
            </p>
        </div>
    </div>
    <br />
    <app-inventory-grid [supplierCode]="supplierCode"></app-inventory-grid>
</div>
